<template>
  <div class="pdf-viewer">
    <div v-show="jsLoaded" id="pdf-content"></div>

    <div v-if="!jsLoaded" class="fallback-container">
      <dummy-viewer :file="file"></dummy-viewer>
    </div>
  </div>
</template>

<script>
  import PDFObject from 'pdfobject'
  import DummyViewer from './DummyViewer.vue'

  export default {
    name: 'pdf-viewer',
    components: {
      'dummy-viewer': DummyViewer,
    },
    props: {
      file: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        jsLoaded: true
      }
    },
    mounted () {
      const options = {
        pdfOpenParams: {
          pagemode: "none",
          zoom: "auto"
        },
        forcePDFJS: true,
        PDFJS_URL: '/lib/pdfjs/web/viewer.html'
      }
      this.jsLoaded = PDFObject.embed(this.url, "#pdf-content", options)
    },
    computed: {
      url () {
        let file_path = '';
        if (this.file && this.file.type === 'document_vault') {
          file_path = this.file.document_vault.url + '/document/' + this.file.document_vault.uuid + '?token=' + this.file.document_vault.auth_token
        } else {
          file_path = this.file.urls.orig
        }
        return file_path // this.path + '?file=' + encodeURIComponent(file_path)
      }
    }
  }
</script>

<style lang="scss">
  .pdf-viewer {
    display: flex;
    flex-direction: column;
    background-color: lightgray;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  #pdf-content {
    height: 100%;
    width: 100%;
  }

  .pdf-viewer {
    object, embed, iframe, .pdfobject-container {
      max-height: 100%;
      max-width: 100%;
      height: 100%;
      width: 100%;
      border: none;
      z-index: 1;
    }
  }

  .fallback-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
